import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import Typography from '@digital-hig/mui/dist/Typography';
import { styleVariables } from './constants';

const StatusPill = ({
  isComplete, isStarted, isViewed, showStatusLoader,
}) => {
  if (showStatusLoader) {
    return <RootElement><Skeleton className="pill-loader" /></RootElement>;
  }
  if (isComplete) {
    return <RootElement className="complete"><Typography variant="smallprint" className="complete">Completed</Typography></RootElement>;
  } if (isStarted) {
    return <RootElement className="started"><Typography variant="smallprint" className="started">In&nbsp;progress</Typography></RootElement>;
  } if (isViewed) {
    return <RootElement className="viewed"><Typography variant="smallprint" className="viewed">Viewed</Typography></RootElement>;
  }
  return <></>;
};

StatusPill.propTypes = {
  isComplete: PropTypes.bool,
  isStarted: PropTypes.bool,
  isViewed: PropTypes.bool,
  showStatusLoader: PropTypes.bool,
};

StatusPill.defaultProps = {
  isComplete: false,
  isStarted: false,
  isViewed: false,
  showStatusLoader: false,
};

const RootElement = styled.div`
  &.pill-loader {
    width: 80px;
    height: 20px;
    border-radius: 10px;
  }
  height: 20px;
  border-radius: 12px;
  padding: 2px 10px;
  line-height: 20px;
  width: fit-content;
  
  p {
    line-height: 20px;
  }
  
  &.complete {
    background: ${styleVariables.fillSuccess};
  }
  
  &.started {
    background-color: ${styleVariables.fillEngage};
    * {
      color: #fff;
    }
  }
  
  &.viewed {
  background-color: ${styleVariables.detail1Opaque};
  }
`;

export default StatusPill;
